import { Amplify } from 'aws-amplify';
import { loadRuntimeConfig } from './runtime-config';

// Configure Amplify with runtime config
export const configureAmplify = async () => {
  const config = await loadRuntimeConfig();

  // Amplify v6 configuration structure
  const amplifyConfig: any = {
    Auth: {
      Cognito: {
        userPoolId: config.userPoolId,
        userPoolClientId: config.userPoolClientId,
        loginWith: {
          oauth: {
            domain: config.cognitoDomain,
            scopes: ['email', 'openid', 'profile'],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code',
            providers: ['AmazonFederate'],
          },
        },
      },
    },
    API: {
      REST: {
        api: {
          endpoint: config.apiUrl,
          region: config.region,
        },
        metricsApi: {
          endpoint: config.apiUrl,
          region: config.region,
        },
      },
    },
  };

  Amplify.configure(amplifyConfig);
};
